/** Типы сущностей, к которым цепляются фотографии. */
export enum ImageObjectType {
  DELIVERY = 1,
  /** Проблема получателя (претензия, зикуй, возврат). */
  PROBLEM = 2,
}

/**
 * Трёхчастный адрес сущности. ObjectID трактуется по типу:
 * для DELIVERY это Delivery_Num, а ObjectSubID — Delivery_Sub (см. Drivers/models/kavData);
 * для PROBLEM это OrderID проблемы, а ObjectSubID всегда 0.
 */
export interface IImageObjectRef {
  ObjectType: ImageObjectType
  ObjectID: number
  ObjectSubID: number
}

/** Любая половина валидна: фотографии без комментария и наоборот. */
export interface IImageUploadPayload {
  files: File[]
  comment: string
}
